import { post } from '@/utils/fetch'
import type { TDeadline } from '@/interfaces/offer'

type GenerateOfferDescriptionParams = {
  keyword: string
  professionalId: string
  categoryId?: string
  deadline?: TDeadline
}

type GenerateOfferDescriptionResult = {
  title: string
  description: string
}

export const generateOfferDescription = async (
  data: GenerateOfferDescriptionParams,
) => {
  return post<GenerateOfferDescriptionResult>(
    '/ai/generate-offer-description',
    data as unknown as Record<string, unknown>,
  )
}
